import React from "react";
import DataStatsSection from "../../../components/datatable/data-stats-section";
import FilterSection from "../../../components/datatable/filter/FilterSection";
import HideFieldSection from "../../../components/datatable/hide/hide-section";
import Datatable from "../../../components/datatable/investors/datatable-investors";
import Pagination from "../../../components/datatable/pagination/pagination";
import ResetTableButton from "../../../components/datatable/reset-table-button";
import SortFieldSection from "../../../components/datatable/sort/sort-section";
import ExpandCardModal from "../../../components/modals/expand-card-modal";
import MessageContainerModal from "../../../components/modals/message-container-modal";
import MoreInfoModal from "../../../components/modals/more-info-modal";
import SearchSection from "../../../components/search/search-section";
import NavBar from "../../navbar/navbar";

/**
 * InvestorsDatatablePage Component
 * 
 * Full-page layout for viewing and filtering investor database. Provides comprehensive data management
 * interface including stats overview, search functionality, filtering by multiple fields, column visibility
 * toggling, sorting options, pagination, and expandable card details. Displays investor records in tabular
 * format with modal interactions for detailed information and expansion views.
 * 
 * @param {Object} props - Component props containing table state and handlers
 * @returns {JSX.Element} Complete datatable page with navbar, stats, filters, search, table, and modals
 */
const DatatablePage = ({ props }) => {
  return (
    <div className="datatable-page-layout">
      <NavBar />

      <MessageContainerModal props={props} />

      <div id="shutdowndata">
        <DataStatsSection props={props} />

        <div className="shutdowndatasearchdiv">
          <div className="shutdowndatahidefieldbuttons">
            {/* filter button */}
            <div className="dropdown shutdownfilterdiv">
              <FilterSection props={props} />
            </div>

            {/* hide field button */}
            <HideFieldSection props={props} />

            {/* Clear all filters and search */}
            <ResetTableButton props={props} />

            {/* sort field button */}
            <SortFieldSection props={props} />

            {/* <div className="shutdownellipsisicon">
                <FaEllipsisH />
              </div> */}
          </div>

          <SearchSection props={props} />
        </div>

        <Datatable props={props} />

        <Pagination props={props} />
      </div>

      {/* pop up modal for more row's info */}
      <MoreInfoModal props={props} />

      {/* expand card modal */}
      <ExpandCardModal props={props} />
    </div>
  );
};

export default DatatablePage;
